/** Base error for all Shroud SDK errors. */
export class ShroudError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'ShroudError';
  }
}

/** Error during WebSocket session setup or communication. */
export class SessionError extends ShroudError {
  readonly code?: string;

  constructor(message: string, code?: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'SessionError';
    this.code = code;
  }
}

/** Error during cryptographic operations. */
export class CryptoError extends ShroudError {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'CryptoError';
  }
}

/** Error during TEE attestation verification. */
export class AttestationError extends ShroudError {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'AttestationError';
  }
}

/** Error during stream reading. */
export class StreamError extends ShroudError {
  readonly code?: string;

  constructor(message: string, code?: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'StreamError';
    this.code = code;
  }
}
